import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

/** Fetch a CMS page by slug. Returns { sections: [...] } */
export const fetchPage = (slug) => api.get(`/pages/${slug}`).then((r) => r.data);

/** Fetch blog posts listing */
export const fetchBlogPosts = () => api.get("/blogs").then((r) => r.data);

/** Fetch single blog post */
export const fetchBlogPost = (slug) => api.get(`/blogs/${slug}`).then((r) => r.data);

/** Submit contact form */
export const submitContact = (data) => api.post("/contacts", data).then((r) => r.data);

/** Helper: extract a section value from page data */
export const getSection = (pageData, key, fallback = "") => {
  if (!pageData) return fallback;
  const s = pageData.sections?.find((s) => s.key === key);
  return s?.value || fallback;
};

export default api;
